import { useV2DeleteServiceAccountCredentialMutation } from "@generated";

interface DeleteInput {
  userId: string;
  credentialId: string;
}

const useDeleteClientCredential = () => {
  const [trigger, { isLoading }] =
    useV2DeleteServiceAccountCredentialMutation();

  const deleteCredential = async (input: DeleteInput): Promise<void> => {
    await trigger({
      userId: input.userId,
      id: input.credentialId,
    }).unwrap();
  };

  return { deleteCredential, isDeleting: isLoading };
};

export default useDeleteClientCredential;
